export default __webpack_public_path__ + "static/38-fit-d1b6a62d79954ad00d6bb1374ff7a03a.png";